export default __webpack_public_path__ + "static/media/sqlserver.a8ae5efe.png";